<template>
  <v-container
    id="step-container"
    class="step-container"
    fill-height
    grid-list-lg>
    <v-layout row wrap>
      <v-flex
        id="step-container--content"
        class="step-container--content"
        xs12
        :md7="hasSidebarSlot"
        :md12="!hasSidebarSlot">
          <div class="step-container--content-container">
            <v-layout>
              <v-flex v-if="hasAlertsSlot" id="step-container--alerts" xs12>
                <slot name="alerts" />
              </v-flex>
            </v-layout>
            <slot />
          </div>
      </v-flex>

      <v-flex
        v-if="hasSidebarSlot"
        id="step-container--sidebar"
        class="step-container--sidebar"
        xs12
        md4
        offset-md1
        hidden-sm-and-down>
        <div class="step-container--sidebar-container">
          <slot name="sidebar" />
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    showSummarySidebar: {
      type: Boolean,
      default: false,
    },
  },
  inject: ['$validator'],
  computed: {
    hasAlertsSlot() {
      return !!this.$slots.alerts;
    },
    hasSidebarSlot() {
      return !!this.$slots.sidebar;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/mixins/breakpoints';
@import '../styles/vars/theme';

$_content-padding: 5.35rem;
$_sidebar-background: darken(saturate(adjust-hue($theme-color-white, 210), 20.00), 1.96);

.step-container {
  overflow: hidden;
  padding-bottom: 0;
  padding-top: 0;

  &--content {
    &-container {
      padding: $_content-padding 0;
      position: relative;
      z-index: 2;
    }
  }

  &--sidebar {
    &-container {
      padding: $_content-padding 0;
      position: relative;
      z-index: 1;
    }
  }

  &--sidebar {
    background: $_sidebar-background;
    position: relative;

    &-container {
      padding-left: 15%;
    }

    &:before {
      background: $_sidebar-background;
      content: '';
      height: 100%;
      position: fixed;
      right: 0;
      top: 0;
      width: 25vw;
      z-index: 1;
    }
  }
}

@include responsive-breakpoint(sm) {
  .step-container {

    &--content,
    &--sidebar {
      &-container {
        padding-top: ($_content-padding / 3);
      }
    }
  }
}
</style>
